import React, { useState } from "react";
import ncmBg3 from "./newtruckoneee.png";
import ncmBg4 from "./ncmMainBg.jpg"; // Import the second background image
import "index.css";
import NavBar from "components/navbar";

function LandingHero() {
  const text = "CAN TMS";

  // State to manage the current image index
  const [currentIndex, setCurrentIndex] = useState(0);

  // Array of background images
  const backgroundImages = [ncmBg3, ncmBg4];

  // Function to handle the next image
  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % backgroundImages.length);
  };

  // Function to handle the previous image
  const prevImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? backgroundImages.length - 1 : prevIndex - 1
    );
  };

  return (
    <section id="heroLanding" className="relative min-h-screen">
      <NavBar />
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-black/50 bg-cover bg-center"
        style={{
          backgroundImage: `url(${backgroundImages[currentIndex]})`,
          backgroundRepeat: "no-repeat",
          transition: "background-image 1s ease-in-out", // Smooth transition
        }}
      />
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-transparent to-black/70 shadow" />

      {/* Navigation Buttons */}
      <button
        className="absolute top-1/2 left-4 z-20 -translate-y-1/2 transform rounded-full bg-black/50 p-2 text-white hover:bg-black/70"
        onClick={prevImage}
      >
        &#10094; {/* Left arrow */}
      </button>
      <button
        className="absolute top-1/2 right-4 z-20 -translate-y-1/2 transform rounded-full bg-black/50 p-2 text-white hover:bg-black/70"
        onClick={nextImage}
      >
        &#10095; {/* Right arrow */}
      </button>

      {/* Welcome Box */}
      <div className="absolute top-1/4 z-10 mx-auto flex w-11/12 flex-col items-start justify-start rounded-lg bg-black/10 p-4 text-left md:left-10 md:w-[90%] md:p-6 lg:w-[550px] lg:p-8">
        {/* Title */}
        <h1 className="mb-2 text-2xl font-bold text-white md:text-3xl">
          Welcome to
        </h1>
        <h1 style={{ whiteSpace: "pre" }}>
          {text.split("").map((letter, index) => (
            <span
              key={index}
              className="text-4xl font-extrabold md:text-6xl"
              style={{
                animation: `letterColor 0.5s forwards`,
                animationDelay: `${index * 0.3}s`, // Adjust delay as needed
                display: "inline-block",
                color: "white",
              }}
            >
              {letter}
            </span>
          ))}
        </h1>

        {/* Description */}
        <p className="mb-2 mt-1 text-left text-base leading-normal text-white">
          We offer a specialized transportation management system designed to
          streamline and optimize the logistics of moving goods.
        </p>

        {/* Highlighted Text */}
        <p className="mb-4 text-left text-base leading-normal text-white">
          One solution for all your logistics problems. Designed and developed
          in
          <span className="font-bold text-crimson"> Nepal.</span>
        </p>

        {/* Button */}
        <div className="flex w-full">
          <button
            className="rounded bg-crimson px-6 py-2 text-sm font-semibold text-white transition hover:scale-[1.02] hover:bg-red-700"
            onClick={() => (window.location.href = "/sign-in")}
          >
            Get Started
          </button>
        </div>
      </div>
    </section>
  );
}

export default LandingHero;
